module.exports = __webpack_public_path__ + "static/media/tractor.8e322305.svg";